<template>
<div>
<div class="sub_visual_wrap">
    <div class="sub_visual_box container">
        <div class="page_nav">
            <ul>
                <li><router-link to="/main" @click.native="$store.commit('setActive','')">{{$t('common.home')}}</router-link></li>
                <li><a href="#">{{$t('management.tsgDictionary')}}</a></li>
            </ul>
        </div>	
        <h2>TSG Dictionary</h2>
    </div>
</div> 
  <section class="container dxp-container">
    <div class="sub_contents_wrap">
    <div class="brick_box">
      <table class="mgt_tbl_v2 mgb_0">
        <tbody>
          <tr>
            <th>Controller Type</th>
            <td>
              <select
                v-model="form.controllerId"
                class="int_type01 mgt_seltype"
                v-validate="'required'"
                style="width:50%;"
                @change="getTpcdList(form.controllerId)"
              >
                <option value="" selected>--{{ $t("common.all") }}--</option>
                <option
                  v-for="(controller, index) in controllerList"
                  :key="index"
                  :value="controller.controllerId"
                >
                  {{ controller.controllerName }}
                </option>
              </select>
            </td>
            <th>Source TPCD</th>
            <td>
              <select
                v-model="form.tpcdId"
                class="int_type01 mgt_seltype"
                v-validate="'required'"
                style="width:50%;"
              >
                <option value="" selected>--{{ $t("common.all") }}--</option>
                <option
                  v-for="(tpcd, index) in tpcdList"
                  :key="index"
                  :value="tpcd.tpcdId"
                >
                  {{ tpcd.tpcdName }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <th>Model Code</th>
            <td>
              <div class="d-flex">
                <div class="w-50">
                  <autocomplete
                    :source="modelCodeList"
                    input-class="autocomplete-input mgt_seltype model-code"
                    ref="autocomplete"
                    @selected="selectModelCode"
                    placeholder="Search a Model Code"
                    @clear="clearModelCode"
                  >
                  </autocomplete>
                </div>
              </div>
            </td>
            <th>Model Name</th>
            <td>
              <div class="d-flex">
                <div class="w-50">
                  <autocomplete
                    :source="modelNameList"
                    input-class="autocomplete-input mgt_seltype model-name"
                    ref="autocomplete"
                    @selected="selectModelName"
                    placeholder="Search a Model Name"
                    @clear="clearModelName"
                  >
                  </autocomplete>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th>Exhaust Certification</th>
            <td>
              <select
                v-model="form.exhaustCertiName"
                class="int_type01 mgt_seltype"
                v-validate="'required'"
                style="width:50%;"
              >
                <option value="" selected>--{{ $t("common.all") }}--</option>
                <option
                  v-for="(ex, index) in exhaustList"
                  :key="index"
                  :value="ex.exhaustCertiName"
                >
                  {{ ex.exhaustCertiName }}
                </option>
              </select>
            </td>
            <th>{{ $t("common.language") }}</th>
            <td>
              <select v-model="form.langCode" class="int_type01 mgt_seltype">
                <option value="" selected>--{{ $t("common.all") }}--</option>
                <option
                  v-for="(lang, index) in langList"
                  :key="index"
                  :value="lang.codeId"
                >
                  {{ lang.codeName }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <th>Error Code</th>
            <td colspan="5">
              <input
                type="text"
                v-model="form.errorCode"
                @keyup.enter="searchBtn"
                class="int_type01 mgt_seltype"
                title="Search Document Name"
                style="width: 100%"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <div class="mgt_option_bottom">
        <button @click="searchBtn" class="btn btn-primary">
          {{ $t("common.search") }}
        </button>
      </div>
    </div>
    <table class="list_tbl_v2">
      <colgroup>
        <col width="10%" />
        <col width="10%" />
        <col width="20%" />
        <col width="20%" />
        <col width="5%" />
        <col width="5%" />
        <col width="10%" />
        <col width="10%" />
        <col width="10%" />
      </colgroup>
      <thead>
        <tr>
          <th class="mobile_h">Controller Type</th>
          <th class="mobile_h">Source TPCD</th>
          <th class="mobile_h">ModelCode</th>
          <th class="mobile_h">ModelName</th>
          <th class="mobile_h">PDF Download</th>
          <th class="mobile_h">Error Code(GP)</th>
          <th class="mobile_h">Error Code(Vendor)</th>
          <th class="mobile_h">Language</th>
          <th class="mobile_h">Written Date</th>
        </tr>
      </thead>
      <tbody v-if="tsgList && tsgList.length != 0">
        <tr v-for="(item, index) in tsgList" :key="index">
          <td>{{ item.controllerName }}</td>
          <td>{{ item.tpcdName }}</td>
          <td v-if="item.modelCode && item.modelCode.length>15">{{ item.modelCode.substring(0, 15) }}...</td>
          <td v-else>{{ item.modelCode }}</td>
          <td v-if="item.modelName && item.modelName.length>15">{{ item.modelName.substring(0, 15) }}...</td>
          <td v-else>{{ item.modelName }}</td>
          <td class="td-filedown" v-if="item.fileNodeRef">
            <div class="file-center"><a
              v-if="item.fileNodeRef"
              @click="
                tsgPdfDownload(
                  item.fileNodeRef.replace('workspace://SpacesStore/', '')
                )
              "
              class="p_l_icon02"
              title="PDF Download"
              >.</a
            ></div>
          </td>
          <td v-else></td>
          <td v-if="item.fileNodeRef">
            <a
              :href="
                '/tsg/preview?noCache=' +
                    date +
                    '&uid=' +
                    item.fileNodeRef.replace('workspace://SpacesStore/', '')
                  "
              class="pdf-view"
              target="_blank"
              title="PDF View"
              >{{ item.errorCodeGp }}</a
            >
          </td>
          <td v-else>{{ item.errorCodeGp }}</td>
          <td>{{ item.errorCodeVendor }}</td>
          <td>{{ item.langName }}</td>
          <td>{{ item.firstRegDatetime | moment("YYYY-MM-DD") }}</td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="8">{{ $t("common.noData") }}</td>
        </tr>
      </tbody>
    </table>
    <div v-if="tsgList && tsgList.length != 0" class="paging_nav">
      <div class="paging_nav">
        <a
          href="#"
          v-if="pagingVO.startPage <= pagingVO.blockSize"
          class="page_select prev_page disabled"
          >이전페이지 이동</a
        >
        <a
          v-else
          class="page_select prev_page"
          @click="searchPage(pagingVO.startPage - pagingVO.blockSize)"
          v-bind:data-page="pagingVO.startPage - pagingVO.blockSize"
          >이전페이지 이동</a
        >
        <span
          v-for="(pages, index) in pagingVO.endPage - pagingVO.startPage + 1"
          :key="index"
        >
          <strong v-if="pagingVO.startPage + index == pagingVO.currentPage">{{
            pagingVO.startPage + index
          }}</strong>
          <a href="#" v-else @click="searchPage(pagingVO.startPage + index)">{{
            pagingVO.startPage + index
          }}</a>
        </span>
        <a
          v-if="pagingVO.endPage >= pagingVO.totalPage"
          href="#"
          class="page_select next_page disabled"
          >다음페이지 이동</a
        >
        <a
          v-else
          href="#"
          @click="searchPage(pagingVO.endPage + 1)"
          v-bind:data-page="pagingVO.endPage + 1"
          class="page_select next_page"
          >다음페이지 이동</a
        >
      </div>
    </div>
    </div>
</section>
</div>
</template>

<script>
import Autocomplete from "vuejs-auto-complete";
import { getTsg } from "@/api/tsg";
import { getTpcdList } from "@/api/tpcd";
import { tsgPdfDownload } from "@/api/tsg";
export default {
  components: {
    Autocomplete,
  },
  data() {
    return {
      tsgId: "",
      tsgList: [],
      controllerList: [],
      tpcdList: [],
      langList: [],
      exhaustList: [],
      modelNameList: [],
      modelCodeList: [],
      pagingVO: "",
      form: {
        tsgId: "",
        controllerId: "",
        tpcdId : "",
        exhaustCertiName: "",
        errorCode: "",
        startDate: "",
        endDate: "",
        searchWord: "",
        searchState: "",
        publishStatus: "",
        modelCode: "",
        modelName : "",
        langCode: "",
        page: 1,
        userId: "",
      },
      date: new Date().toISOString(),
    };
  },
  mounted() {
    var searchForm = this.$route.params.searchForm;
    if(searchForm){
      this.form = searchForm;
    }
    this.fetchData(this.form);
  },
  methods: {
    // 분류조회
    async fetchData(form) {
      try {
        let loader = this.$loading.show({});
        const resp = await getTsg(form);
        console.log(resp);
        this.tsgList = resp.data.pagingVO.dataList;
        this.controllerList = resp.data.controllerList;
        this.tpcdList = resp.data.tpcdList;
        this.langList = resp.data.langList;
        this.exhaustList = resp.data.exhaustList;
        this.pagingVO = resp.data.pagingVO;
        this.langList = resp.data.langList;
        this.modelCodeList = resp.data.modelCodeList;
        this.modelNameList = resp.data.modelNameList;
        loader.hide();
      } catch (err) {
        console.log(err);
      }
    },
    checkDate() {
      if (this.form.endDate != "" && this.form.startDate != "") {
        if (this.form.endDate < this.form.startDate) {
          alert(this.$t("alert.checkDate"));
          this.form.endDate = "";
          this.form.startDate = "";
          return;
        }
      }
    },
    searchPage(page) {
      // 페이지 클릭 시
      this.form.page = page;
      this.fetchData(this.form);
    },
    searchBtn() {
      this.form.page = 1;
      this.fetchData(this.form);
    },
    async getTpcdList(upperControllerId){
      this.tpcdList = [];
      if(upperControllerId){
        const resp = await getTpcdList(upperControllerId);
        this.tpcdList = resp.data.tpcdList;
      }
    },
    selectModelCode(selection){
      this.form.modelCode = selection.display;
    },
    selectModelName(selection){
      this.form.modelName = selection.display;
    },
    clearModelCode(){
      this.form.modelCode='';
    },
    clearModelName(){
      this.form.modelName='';
    },
    async tsgPdfDownload(uid) {
      let loader = this.$loading.show({});
      const response = await tsgPdfDownload(uid);
      if(response){
        if (response.data.status) {
          loader.hide();
          window.open("/tsg/download/pdf?uid=" + uid);
        } else {
          loader.hide();
          alert("Download failed");
        }
      }else{
        loader.hide();
        alert("Download failed");
      }
      
    },
  }
};
</script>

<style>
.b-form-datepicker {
  height: 35px !important;
  padding: 2px 0 15px 0;
}
.mgt_option_bottom {
  margin-bottom: 0px;
  border-bottom: 0px;
}
.brick_box {
  margin-bottom: 30px;
}
.pdf-view{
  text-decoration: underline;
  color: #e25a09;
}
.autocomplete__box{
  width: 235px;
}
header {
  display: none !important;
}
.sub_visual_wrap {
    margin-top: 0px !important;
}

@media (max-width: 768px) {
    .sub_contents_wrap {
        padding: 40px 0px 40px 0px;
    }
}
</style>
